<div *ngIf="(showDiv.current || showImport.current)">
  <div class="modal-header" *ngIf="editMode">
    <span class="modal-title">{{ title }}</span>
  </div>
  <div class="modal-sub-text" *ngIf="editMode">{{ subText }}</div>

  <div class="modal-header modal-header-readonly" *ngIf="!editMode">
    <span class="modal-title">{{ "modules.expert-tool.edit-result-readonly-header" | transloco }}</span>
  </div>

  <div class="modal-body">
    <form [formGroup]="form">
      <div class="row form-group">
        <div class="col-6">
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="SG_DiogName">{{
                    "modules.expert-tool.diog-name" | transloco
                  }}</label>
                <input
                  appTrim
                  type="text"
                  autocomplete="off"
                  class="form-control small-size"
                  id="SG_DiogName"
                  formControlName="SG_DiogName"
                  [readonly]="!editMode"
                />
              </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <label for="SG_REFNR">{{
                    "modules.expert-tool.hwsnr" | transloco
                  }}</label>
                <input
                  appTrim
                  type="text"
                  autocomplete="off"
                  class="form-control small-size"
                  id="SG_REFNR"
                  formControlName="SG_REFNR"
                  [readonly]="!editMode"
                  [class.is-invalid]="isInputInvalid('SG_REFNR')"
                />
              </div>
            </div>
          </div>

          <div class="row add-space">
            <div class="col-12">
              <label for="attributesVpRate">{{
                  "modules.expert-tool.attributes-label" | transloco
                }}</label>
              <textarea
                appTrim
                class="form-control small-size"
                id="attributesVpRate"
                formControlName="attributes"
                [readonly]="!editMode"
                rows="4"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="col-6">
          <label for="FW_KETTE">{{
              "modules.expert-tool.result.labels.etkette" | transloco
            }}</label>
          <textarea
            appTrim
            class="form-control small-size"
            id="FW_KETTE"
            formControlName="FW_KETTE"
            [readonly]="!editMode"
            rows="7"
          ></textarea>
        </div>
      </div>

      <div class="row form-group add-space">
        <div class="col-3">
          <div class="form-group">
            <label for="ECU_Refer">{{
                "modules.expert-tool.result.labels.ecu-ref-sg" | transloco
              }}</label>
            <textarea
              appTrim
              type="text"
              autocomplete="off"
              class="form-control small-size"
              id="ECU_Refer"
              formControlName="ECU_Refer"
              [readonly]="!editMode"
            ></textarea>
          </div>
        </div>

        <div class="col-3">
          <div class="form-group">
            <label for="VP_Methode">{{
                "modules.expert-tool.result.labels.vp" | transloco
              }}</label>
            <input
              appTrim
              type="text"
              autocomplete="off"
              class="form-control small-size"
              id="VP_Methode"
              formControlName="VP_Methode"
              readonly
            />
          </div>
        </div>

        <div class="col-3">
          <div class="form-group">
            <label for="Flashbedarf">{{
                "modules.expert-tool.result.datatable.flash-requirement"
                  | transloco
              }}</label>
            <input
              appTrim
              type="text"
              autocomplete="off"
              class="form-control small-size"
              id="Flashbedarf"
              formControlName="Flashbedarf"
              readonly
            />
          </div>
        </div>
      </div>
    </form>

    <div class="row control-units-table">
      <!-- 1st table -->
      <div class="col-3">
        <div>
          <div class="row add-space">
            <div class="col-6 round-button-container">
              <span class="sub-title">{{
                  "modules.expert-tool.fw-on-cu" | transloco
                }}</span>
                <span 
                  [ngClass]="{'no-drop-cursor': fwmbsRows === undefined || (!fwmbsRows.length)}"
                  title="{{
                    'modules.expert-tool.copy-records' | transloco
                  }}"
                  class="round-button-container"
                  *ngIf="editMode"
                >
                  <span 
                    (click)="copyFwmbsRows()"
                    [ngClass]="{'disabled': fwmbsRows === undefined || (!fwmbsRows.length)}"
                  >
                    <i class="bi bi-box-arrow-up-right main-icon"></i>
                  </span>
                </span>
            </div>
          </div>

          <div class="data-table">
            <ngx-datatable
              #dataTable
              class="material datatable-scrollable"
              [columnMode]="'flex'"
              [headerHeight]="56"
              rowHeight="auto"
              [rows]="fwmbsRows"
              [selectionType]="dataTableSelection"
              [messages]="{
                emptyMessage:
                  'modules.expert-tool.empty-table-result-modal' | transloco
              }"
            >
              <ngx-datatable-column
                name="{{ 'modules.expert-tool.fw-on-cu' | transloco }}"
                prop="FW_MBS"
                [flexGrow]="6"
                [resizeable]="false"
                [sortable]="false"
              >
                <ng-template
                  let-value="value"
                  let-row="row"
                  ngx-datatable-cell-template
                  let-rowIndex="rowIndex"
                >
                  <inline-editing-cell
                    (updateDatatable)="updateFwmbsDatatable($event)"
                    [primaryKey]="'id'"
                    [secondaryKey]="'SG_DiogName'"
                    [row]="row"
                    [cellPropertyName]="'FW_MBS'"
                    [cellPropertyValue]="value"
                    [data]="fwmbsRows"
                    [orignalData]="orignalFwmbsRows"
                    [validationHighlightKey]="'FW_MBS'"
                    [isFwNumbersValid]="isFwNumberValid"
                    [allowEmpty]="true"
                  >
                  </inline-editing-cell>
                </ng-template>

                <ng-template
                  let-value="value"
                  let-column="column"
                  let-rowIndex="rowIndex"
                  let-sort="sortFn"
                  ngx-datatable-header-template
                >
                  <span
                    class="header-sort datatable-header-cell-label"
                    ngbTooltip="{{ fwmbsRowsToolTip }}"
                    data-container="body"
                    container="body"
                    placement="bottom"
                    tooltipClass="note-tooltip"
                  >{{ column.name }}</span
                  >
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
            <input
              #newFwmbsInput
              *ngIf="editMode"
              type="text"
              autocomplete="off"
              class="form-control small-size mt-2 fw-on-ecu"
              placeholder="+ Add Value"
              [class.is-invalid]="newFwmbsInputInvalid"
              [attr.aria-invalid]="newFwmbsInputInvalid"
              [attr.aria-label]="'modules.expert-tool.fw-on-cu' | transloco"
              (input)="newFwmbsInputInvalid = false"
              (keydown.enter)="$event.preventDefault(); addFwmbsValue(newFwmbsInput)"
            />
          </div>
        </div>
      </div>

      <!--   2nd table -->

      <div class="col-9">
        <div>
          <div class="result"></div>
          <div class="row add-space">
            <div class="col-6 round-button-container">
              <span class="sub-title">{{
                  "modules.expert-tool.result.labels.det-fw-title" | transloco
                }}</span>
                <span 
                  title="{{
                    'modules.expert-tool.insert-new-line' | transloco
                  }}"
                  (click)="openAddNewRecordView()"
                  *ngIf="editMode"
                >
                  <i class="bi bi-plus main-icon"></i>
                </span>
                <span 
                  title="{{
                    'modules.expert-tool.mutli-import' | transloco
                  }}"
                  (click)="openMultiImportRecordView()"
                  *ngIf="editMode"
                >
                  <i class="bi bi-layers-fill main-icon"></i>
                </span>
            </div>
          </div>


          <div class="data-table result-table">
            <ngx-datatable
              #dataTable
              class="material datatable-scrollable"
              [columnMode]="'flex'"
              [headerHeight]="56"
              rowHeight="auto"
              [rows]="determinedRows"
              [selectionType]="dataTableSelection"
              [messages]="{
                emptyMessage:
                  'modules.expert-tool.empty-table-result-modal' | transloco
              }"
              [selectionType]="dataTableSelection"
              [selectAllRowsOnPage]="false"
              [selected]="selected"
              (select)="onSelect($event)"
            >
              <ngx-datatable-column
                [cellClass]="'text-center'"
                name="{{
                  'modules.expert-tool.result.labels.flash-selection'
                    | transloco
                }}"
                prop="selected"
                [width]="25"
                [sortable]="false"
                [canAutoResize]="false"
                [draggable]="false"
                [resizeable]="false"
                *ngIf="editMode"
              >
                <ng-template
                  ngx-datatable-cell-template
                  let-value="value"
                  let-isSelected="isSelected"
                  let-onCheckboxChangeFn="onCheckboxChangeFn"
                  let-row="row"
                  let-rowIndex="rowIndex"
                >
                  <label class="checkbox-container">
                    <input
                      type="checkbox"
                      [checked]="isSelected"
                      (change)="onCheckboxChangeFn($event)"
                    />
                    <span
                      class="checkmark"
                      ngbTooltip="{{
                        'modules.expert-tool.result.labels.flash-selection'
                          | transloco : { value: value }
                      }}"
                      data-container="body"
                      container="body"
                      placement="bottom"
                      tooltipClass="note-tooltip"
                    ></span>
                  </label>
                </ng-template>

                <ng-template
                  ngx-datatable-header-template
                  let-value="value"
                  let-column="column"
                  let-rowIndex="rowIndex"
                  let-allRowsSelected="allRowsSelected"
                  let-selectFn="selectFn"
                >
                  <label class="checkbox-container">
                    <input
                      type="checkbox"
                      checked="checked"
                      [checked]="allRowsSelected"
                      (change)="selectFn(!allRowsSelected)"
                    />
                    <span
                      class="checkmark"
                      ngbTooltip="{{
                        'modules.expert-tool.result.labels.flash-selection'
                          | transloco : { value: value }
                      }}"
                      data-container="body"
                      container="body"
                      placement="bottom"
                      tooltipClass="note-tooltip"
                    ></span>
                  </label>
                </ng-template>

                <ng-template
                  ngx-datatable-cell-template
                  let-value="value"
                  let-isSelected="isSelected"
                  let-onCheckboxChangeFn="onCheckboxChangeFn"
                >
                  <label class="checkbox-container">
                    <input
                      type="checkbox"
                      [checked]="isSelected"
                      (change)="onCheckboxChangeFn($event)"
                    />
                    <span class="checkmark"></span>
                  </label>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column
                name="{{
                  'modules.expert-tool.result.labels.flashware' | transloco
                }}"
                prop="SG_FITTINGFLASHSW"
                [flexGrow]="6"
                [resizeable]="false"
                [sortable]="false"
              >
                <ng-template
                  let-value="value"
                  let-row="row"
                  ngx-datatable-cell-template
                  let-rowIndex="rowIndex"
                >
                  <inline-editing-cell
                    (updateDatatable)="updateDeterminedDatatable($event)"
                    [primaryKey]="'id'"
                    [secondaryKey]="'SG_FITTINGFLASHSW'"
                    [row]="row"
                    [cellPropertyName]="'SG_FITTINGFLASHSW'"
                    [cellPropertyValue]="value"
                    [data]="determinedRows"
                    [orignalData]="orignalDeterminedRows"
                    [longText]="true"
                    [disabled]="true"
                  >
                  </inline-editing-cell>
                </ng-template>

                <ng-template
                  let-value="value"
                  let-column="column"
                  let-rowIndex="rowIndex"
                  let-sort="sortFn"
                  ngx-datatable-header-template
                >
                  <span
                    class="header-sort datatable-header-cell-label"
                    ngbTooltip="{{ detectedFlashwareTooltip }}"
                    data-container="body"
                    container="body"
                    placement="bottom"
                    tooltipClass="note-tooltip"
                  >{{ column.name }}</span
                  >
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column
                name="{{
                  'modules.expert-tool.result.labels.prio' | transloco
                }}"
                prop="SG_FITTINGFLASHSW_PRIO"
                [flexGrow]="3"
                [resizeable]="false"
                [sortable]="false"
              >
                <ng-template
                  let-value="value"
                  let-row="row"
                  ngx-datatable-cell-template
                  let-rowIndex="rowIndex"
                >
                  <inline-editing-cell
                    (updateDatatable)="updateDeterminedDatatable($event)"
                    [primaryKey]="'id'"
                    [secondaryKey]="'SG_FITTINGFLASHSW'"
                    [row]="row"
                    [cellPropertyName]="'SG_FITTINGFLASHSW_PRIO'"
                    [cellPropertyValue]="value"
                    [data]="determinedRows"
                    [orignalData]="orignalDeterminedRows"
                    [disabled]="true"
                  >
                  </inline-editing-cell>
                </ng-template>

                <ng-template
                  let-value="value"
                  let-column="column"
                  let-rowIndex="rowIndex"
                  let-sort="sortFn"
                  ngx-datatable-header-template
                >
                  <span
                    class="header-sort datatable-header-cell-label"
                    ngbTooltip="{{
                      'modules.expert-tool.result.labels.prio'
                        | transloco : { value: value }
                    }}"
                    data-container="body"
                    container="body"
                    placement="bottom"
                    tooltipClass="note-tooltip"
                  >{{ column.name }}</span
                  >
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column
                name="{{
                  'modules.expert-tool.result.labels.size' | transloco
                }}"
                prop="SG_FITTINGFLASHSW_SIZE"
                [flexGrow]="5"
                [resizeable]="false"
                [sortable]="false"
              >
                <ng-template
                  let-value="value"
                  let-row="row"
                  ngx-datatable-cell-template
                  let-rowIndex="rowIndex"
                >
                  <inline-editing-cell
                    (updateDatatable)="updateDeterminedDatatable($event)"
                    [primaryKey]="'id'"
                    [secondaryKey]="'SG_FITTINGFLASHSW'"
                    [row]="row"
                    [cellPropertyName]="'SG_FITTINGFLASHSW_SIZE'"
                    [cellPropertyValue]="value"
                    [data]="determinedRows"
                    [orignalData]="orignalDeterminedRows"
                    [longText]="true"
                    [disabled]="true"
                  >
                  </inline-editing-cell>
                </ng-template>

                <ng-template
                  let-value="value"
                  let-column="column"
                  let-rowIndex="rowIndex"
                  let-sort="sortFn"
                  ngx-datatable-header-template
                >
                  <span
                    class="header-sort datatable-header-cell-label"
                    ngbTooltip="{{
                      'modules.expert-tool.result.labels.size'
                        | transloco : { value: value }
                    }}"
                    data-container="body"
                    container="body"
                    placement="bottom"
                    tooltipClass="note-tooltip"
                  >{{ column.name }}</span
                  >
                </ng-template>
              </ngx-datatable-column>

              <!-- prop="SG_FITTING_FWINFO" -->

              <ngx-datatable-column
                name="{{
                  'modules.expert-tool.result.labels.type' | transloco
                }}"
                prop="type"
                [flexGrow]="3"
                [resizeable]="false"
                [sortable]="false"
              >
                <ng-template
                  let-value="value"
                  let-row="row"
                  ngx-datatable-cell-template
                  let-rowIndex="rowIndex"
                >
                  <inline-editing-cell
                    (updateDatatable)="updateDeterminedDatatable($event)"
                    [primaryKey]="'id'"
                    [secondaryKey]="'SG_FITTINGFLASHSW'"
                    [row]="row"
                    [cellPropertyName]="'type'"
                    [cellPropertyValue]="value"
                    [data]="determinedRows"
                    [orignalData]="orignalDeterminedRows"
                    [disabled]="true"
                  >
                  </inline-editing-cell>
                </ng-template>

                <ng-template
                  let-value="value"
                  let-column="column"
                  let-rowIndex="rowIndex"
                  let-sort="sortFn"
                  ngx-datatable-header-template
                >
                  <span
                    class="header-sort datatable-header-cell-label"
                    ngbTooltip="{{
                      'modules.expert-tool.result.labels.type'
                        | transloco : { value: value }
                    }}"
                    data-container="body"
                    container="body"
                    placement="bottom"
                    tooltipClass="note-tooltip"
                  >{{ column.name }}</span
                  >
                </ng-template>
              </ngx-datatable-column>

              <!-- prop="SG_NEWFLASHSW_FLASHWEG" -->
              <ngx-datatable-column
                name="{{
                  'modules.expert-tool.result.labels.flash-way' | transloco
                }}"
                prop="flashweg"
                [flexGrow]="4"
                [resizeable]="false"
                [sortable]="false"
              >
                <ng-template
                  let-value="value"
                  let-row="row"
                  ngx-datatable-cell-template
                  let-rowIndex="rowIndex"
                >
                  <inline-editing-cell
                    (updateDatatable)="updateDeterminedDatatable($event)"
                    [primaryKey]="'id'"
                    [secondaryKey]="'SG_FITTINGFLASHSW'"
                    [row]="row"
                    [cellPropertyName]="'flashweg'"
                    [cellPropertyValue]="value"
                    [data]="determinedRows"
                    [orignalData]="orignalDeterminedRows"
                    [disabled]="true"
                  >
                  </inline-editing-cell>
                </ng-template>

                <ng-template
                  let-value="value"
                  let-column="column"
                  let-rowIndex="rowIndex"
                  let-sort="sortFn"
                  ngx-datatable-header-template
                >
                  <span
                    class="header-sort datatable-header-cell-label"
                    ngbTooltip="{{
                      'modules.expert-tool.result.labels.flash-way'
                        | transloco : { value: value }
                    }}"
                    data-container="body"
                    container="body"
                    placement="bottom"
                    tooltipClass="note-tooltip"
                  >{{ column.name }}</span
                  >
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column
                name="{{
                  'modules.expert-tool.result.labels.latebound' | transloco
                }}"
                prop="latebound"
                [flexGrow]="9"
                [resizeable]="false"
                [sortable]="false"
              >
                <ng-template
                  let-value="value"
                  let-row="row"
                  ngx-datatable-cell-template
                  let-rowIndex="rowIndex"
                >
                  <inline-editing-cell
                    (updateDatatable)="updateDeterminedDatatable($event)"
                    [primaryKey]="'id'"
                    [secondaryKey]="'SG_FITTINGFLASHSW'"
                    [row]="row"
                    [cellPropertyName]="'latebound'"
                    [cellPropertyValue]="value"
                    [data]="determinedRows"
                    [orignalData]="orignalDeterminedRows"
                    [longText]="true"
                    [disabled]="true"
                  >
                  </inline-editing-cell>
                </ng-template>

                <ng-template
                  let-value="value"
                  let-column="column"
                  let-rowIndex="rowIndex"
                  let-sort="sortFn"
                  ngx-datatable-header-template
                >
                  <span
                    class="header-sort datatable-header-cell-label"
                    ngbTooltip="{{
                      'modules.expert-tool.result.labels.latebound'
                        | transloco : { value: value }
                    }}"
                    data-container="body"
                    container="body"
                    placement="bottom"
                    tooltipClass="note-tooltip"
                  >{{ column.name }}</span
                  >
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column
                [cellClass]="'text-center'"
                name="{{ 'global.actions' | transloco }}"
                [flexGrow]="6"
                [sortable]="false"
                [resizeable]="false"
                *ngIf="editMode"
              >
                <ng-template
                  let-rowIndex="rowIndex"
                  let-row="row"
                  let-value="value"
                  ngx-datatable-cell-template
                >
                  <span 
                    title="{{
                      'modules.expert-tool.tooltip.edit-row' | transloco
                    }}"
                    (click)="openEditRecordView(row, rowIndex)"
                  >
                    <i class="bi bi-pencil"></i>
                  </span>
                  <span 
                    title="{{
                      'modules.expert-tool.tooltip.delete-row' | transloco
                    }}"
                    (click)="deleteFlashRecord(row)"
                  >
                    <i class="bi bi-trash"></i>
                  </span>
                </ng-template>

                <ng-template
                  let-value="value"
                  let-column="column"
                  let-rowIndex="rowIndex"
                  ngx-datatable-header-template
                >
                  <span
                    ngbTooltip="{{
                      'global.actions' | transloco : { value: value }
                    }}"
                    data-container="body"
                    container="body"
                    placement="bottom"
                    tooltipClass="note-tooltip"
                  >{{ column.name }}</span
                  >
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="form.invalid" class="mt-3">
      <app-upload-duration
        [isError]="true"
        [translationKey]="'global.validation.input-length-10'"
      ></app-upload-duration>
    </div>

    <div *ngIf="(newFwmbsInputInvalid || checkFwmbsRecordsLength() || (!isFwNumberValidationPending && !isFwNumberValid)) && editMode" class="mt-3">
      <app-upload-duration
        [isError]="true"
        [translationKey]="'global.validation.table-cell-10'"
      ></app-upload-duration>
    </div>
  </div>

  <div class="modal-footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="button-area float-start">
            <div class="displayed">
              <button
                *ngIf=" (showDiv.next || showImport.next)"
                [ngStyle]="{ display: (showDiv.next || showImport.next) ? 'display' : 'none' }"
                type="button"
                class="btn btn-secondary back"
                (click)="backToFirstView()"
              >
                {{ "global.back" | transloco }}
              </button>
            </div>
          </div>

          <div class="button-area float-end">
            <div class="displayed">
              <button
                *ngIf="(showDiv.current || showImport.current) && editMode"
                [ngStyle]="{ display: (showDiv.current || showImport.current) ? 'display' : 'none' }"
                type="button"
                class="btn btn-secondary"
                (click)="cancel()"
              >
                {{ "global.cancel" | transloco }}
              </button>

              <button
                *ngIf="(showDiv.current || showImport.current) && editMode && showFlashNewSWBtn"
                [ngStyle]="{ display: (showDiv.current || showImport.current) ? 'display' : 'none' }"
                type="button"
                class="btn btn-primary"
                (click)="flashNewSW()"
              >
                Flash New Software & Apply Changes
              </button>

              <button
                *ngIf="(showDiv.current || showImport.current) && editMode"
                [disabled]="form.invalid || newFwmbsInputInvalid || isFwNumberValidationPending || !isFwNumberValid || checkFwmbsRecordsLength()"
                [ngStyle]="{ display: (showDiv.current || showImport.current) ? 'display' : 'none' }"
                type="button"
                class="btn btn-primary"
                (click)="save()"
              >
                {{ buttonText }}
              </button>

              <button
                *ngIf="(showDiv.current || showImport.current) && !editMode"
                [ngStyle]="{ display: (showDiv.current || showImport.current) ? 'display' : 'none' }"
                type="button"
                class="btn btn-primary"
                (click)="cancel()"
              >
                {{ "global.close" | transloco }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showDiv.next">
  <app-fcsc-determined-flashware-insert
    [showDiv]="showDiv"
    (sendDataToFirstView)="eventFromSecondView($event)"
    [data]="dataFromChild"
  >
  </app-fcsc-determined-flashware-insert>
</div>

<div *ngIf="showImport.next">
  <app-fcsc-flashware-multiimport
    [showImport]="showImport"
    (sendMultiImportData)="eventFromSecondView($event)"
  >
  </app-fcsc-flashware-multiimport>
</div>
